import { GENERATE_URL } from "@services/helpers/request";
export const GetAll = (options) => GENERATE_URL("/TagTimeline/GetAll", options);
export default { GetAll };
